import { environment } from 'src/environments/environment';

export class Design {
  public constructor(
    public designId: string,
    public superDesign: string,
    public authorizationGroup: string,
    public launchDescription: string,
    public globalLaunchDate: Date | undefined,
    public designDescription: string,
    public qa40Check: boolean,
    public qa20Check: boolean,
    public designer: string,
    public designerName: string,
    public responsibleUser: string,
    public responsibleName: string,
    public makeBuy: string,
    public usability: string,
    public usabilityText: string,
    public materialGroup: string
  ) {}

  public get imageUrl(): string {
    return `${environment.designImageUrl}/${this.designId}.jpg`;
  }
}
